import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackScreenView } from "@/lib/analytics";
import { screenNameForPath } from "@/lib/screenNames";

/**
 * Report a descriptive screen name to native analytics on every route change,
 * so the Firebase/GA4 user-journey report shows real screens ("app · wallet",
 * "checkout · payment result") instead of one repeated Activity name.
 *
 * No-ops on the web (trackScreenView is native-only) — GA4 already records
 * page_view per route there via GTM.
 */
export function useScreenTracking(): void {
  const { pathname } = useLocation();
  useEffect(() => {
    trackScreenView(screenNameForPath(pathname));
  }, [pathname]);
}
